/**
 * CSS selector matching all natively focusable/tabbable elements.
 * Used for focus-trap logic and carousel focus management.
 */
export const FOCUSABLE_SELECTOR =
  'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
